module.exports = __webpack_public_path__ + "img/contracting.9302ace1.png";